// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"587":"1055bed8","787":"ba59b113"}[chunkId] + ".chunk.js";
};